import allabis, {
  geyser_abi,
  geyser_abi_single,
  geyser_abi_single_new,
  geyser_btcSNOW,
  geyser_btcSNOW_old,
  geyser_crvETH,
  geyser_eth2SNOW,
  geyser_fusd,
  geyser_ousd,
  geyser_poly_usdSnow,
  geyser_poly_usdcSnow,
  geyser_poly_SnowEth,
  geyser_poly_Snow_1,
  geyser_poly_Snow_2,
  geyser_poly_Snow_3,
  geyser_eth_Snow1,
  geyser_eth_Snow2,
  geyser_eth_Snow3,
  geyser_poly_usdSnow_1,
  geyser_poly_usdSnow_2,
  geyser_poly_usdSnow_3,
  geyser_snow,
  geyser_snow_crazy,
  geyser_snow_eth,
  geyser_snow_eth_old,
  geyser_snow_eth_old_old,
  geyser_snow_old,
  geyser_wbtc,
  geyser_wbtc_old,
  geyser_ycrvsnow,
  geyser_ycrvsnow_old,
  geyser_ycrvsnow_snow,
  geyser_ysnow,
  geyser_ysnow_old,
  geyser_ysnow_snow,
  geyser_yVault2,
  geyser_yVault3,
  minter_address,
  snow_address,
  snow_address_polygon,
  boosted_abi,
} from "../allabis";
import Vue from "vue";
import { config } from "../config";

export const networksContracts = {
  eth: {
    iearn: allabis.iearn,
    busd: allabis.busd,
    pusd: allabis.pusd,
    ethsnow: allabis.ethsnow,
    fusd: allabis.fusd,
    crveth: allabis.crveth,
    yvault2: allabis.yvault2,
    yvault3: allabis.yvault3
  },
  rin: {
    '3pool': allabis.threePool_rin,
  },
  matic: {
    usdsnow: allabis.poly_usdSnow,
    usdcsnow: allabis.poly_usdcSnow,
    snoweth: allabis.poly_snowEth,
  },
  maticmum: {}
}

export const networksGeysers = {
  eth: {
    fusdGeyser: {
      abi: geyser_abi_single,
      address: geyser_fusd,
    },
    crvEthGeyser: {
      abi: geyser_abi_single,
      address: geyser_crvETH,
    },
    snowGeyser: {
      abi: geyser_abi,
      address: geyser_snow_eth_old_old
    },
    eth_snowGeyser: {
      abi: geyser_abi_single,
      address: geyser_snow_eth
    },
    eth_snowGeyser_old: {
      abi: geyser_abi_single,
      address: geyser_snow_eth_old
    },
    ySnowGeyser: {
      abi: geyser_abi,
      address: geyser_ysnow_snow
    },
    ycrvSnowGeyser: {
      abi: geyser_abi,
      address: geyser_ycrvsnow_snow
    },
    singleSnowGeyser: {
      abi: geyser_abi_single_new,
      address: geyser_snow
    },
    singleSnowGeyser_crazy: {
      abi: geyser_abi_single_new,
      address: geyser_snow_crazy
    },
    singleSnowGeyser_old: {
      abi: geyser_abi_single,
      address: geyser_snow_old
    },
    singleYSnowGeyser: {
      abi: geyser_abi_single_new,
      address: geyser_ysnow
    },
    singleYSnowGeyser_old: {
      abi: geyser_abi_single,
      address: geyser_ysnow_old
    },
    singleYcrvSnowGeyser: {
      abi: geyser_abi_single_new,
      address: geyser_ycrvsnow
    },
    singleYcrvSnowGeyser_old: {
      abi: geyser_abi_single,
      address: geyser_ycrvsnow_old
    },
    singleWbtcGeyser: {
      abi: geyser_abi_single,
      address: geyser_wbtc
    },
    singleWbtcGeyser_old: {
      abi: geyser_abi_single,
      address: geyser_wbtc_old
    },
    btcSNOWGeyser: {
      abi: geyser_abi_single_new,
      address: geyser_btcSNOW
    },
    btcSNOWGeyser_old: {
      abi: geyser_abi_single,
      address: geyser_btcSNOW_old
    },
    eth2SNOWGeyser: {
      abi: geyser_abi_single_new,
      address: geyser_eth2SNOW
    },
    yVault2Geyser: {
      abi: geyser_abi_single,
      address: geyser_yVault2
    },
    yVault3Geyser: {
      abi: geyser_abi_single,
      address: geyser_yVault3
    },
    singleOusdGeyser: {
      abi: geyser_abi_single,
      address: geyser_ousd
    },
    aRewards: {
      abi: allabis.iearn.aRewards_abi,
      address: allabis.iearn.aRewards_address
    },
    curveRewards: {
      abi: allabis.iearn.sCurveRewards_abi,
      address: allabis.iearn.sCurveRewards_address
    },
    snowGeyser1: {
      abi: boosted_abi,
      address: geyser_eth_Snow1,
    },
    snowGeyser2: {
      abi: boosted_abi,
      address: geyser_eth_Snow2,
    },
    snowGeyser3: {
      abi: boosted_abi,
      address: geyser_eth_Snow3,
    },
  },
  rin: {},
  matic: {
    usdSnowGeyser: {
      abi: geyser_abi_single,
      address: geyser_poly_usdSnow,
    },
    usdcSnowGeyser: {
      abi: geyser_abi_single,
      address: geyser_poly_usdcSnow,
    },
    snowGeyserPol1: {
      abi: boosted_abi,
      address: geyser_poly_Snow_1,
    },
    snowGeyserPol2: {
      abi: boosted_abi,
      address: geyser_poly_Snow_2,
    },
    snowGeyserPol3: {
      abi: boosted_abi,
      address: geyser_poly_Snow_3,
    },
    usdSnowGeyser1: {
      abi: boosted_abi,
      address: geyser_poly_usdSnow_1,
    },
    usdSnowGeyser2: {
      abi: boosted_abi,
      address: geyser_poly_usdSnow_2,
    },
    usdSnowGeyser3: {
      abi: boosted_abi,
      address: geyser_poly_usdSnow_3,
    },
  },
  maticmum: {}
}

export const minterAddresses = {
  eth: minter_address,
  rin: '',
  matic: '',
  maticmum: '',
}

export const snowAddresses = {
  eth: snow_address,
  rin: '',
  matic: snow_address_polygon,
  maticmum: '',
}

export const contracts = Vue.observable(networksContracts[config.network.shortName])
export const geysers = Vue.observable(networksGeysers[config.network.shortName])
export const snowAddress = Vue.observable({ address: snowAddresses[config.network.shortName] })
export const minterAddress = Vue.observable({ address: minterAddresses[config.network.shortName] })
